import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import React from 'react';

export default function FormCard(props) {
  const stripe = useStripe();
  const elements = useElements();
  const cardElementRef = React.useRef(null);

  const handleReady = () => {
    const element = elements.getElement(CardElement);
    cardElementRef.current = element;

    // Notify the parent that the item is ready
    if (props.onCardReady) {
      props.onCardReady(element);
    }
  };

  const handleError = (error) => {
    if (error.type === 'api_connection_error') {
      error.message =
        'Unable to connect to the payment service. Please check your internet connection and try again.';
    }
    return error;
  };

  const handleSubmit = async () => {
    props.setLoadingStripeToken(true);
    if (!stripe || !elements) {
      props.errorMessage(
        'An error occurred while loading Stripe. Please refresh the page and try again',
      );
      return;
    }

    const dataCard = elements.getElement(CardElement);
    const infoCard = props.cardData;

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: 'card',
      card: dataCard,
    });
    if (error) {
      props.errorMessage(handleError(error).message);
      props.dataCard({ element: '', zip: '', tokenCard: '' });
    } else {
      props.errorMessage('');
    }

    const { token, error: errorToken } = await stripe.createToken(
      dataCard,
      infoCard,
    );

    if (errorToken) {
      props.errorMessage(handleError(errorToken).message);
      props.dataCard({ element: '', zip: '', tokenCard: '' });
    } else if (paymentMethod) {
      const zip = paymentMethod.billing_details.address.postal_code;
      props.errorMessage('');
      props.dataCard({ element: dataCard, zip, tokenCard: token?.id });
    }
    props.setLoadingStripeToken(false);
  };

  const cardElementOptions = {
    disableLink: true,
    style: {
      base: {
        fontSize: '1.2rem',
        color: '#32325d',
        '::placeholder': {
          color: '#aab7c4',
        },
      },
      invalid: {
        color: '#fa755a',
      },
    },
  };
  return (
    <form id="payment-form" style={props.style} onSubmit={handleSubmit}>
      <CardElement
        id="card-element"
        onBlur={handleSubmit}
        onReady={handleReady}
        options={cardElementOptions}
      />
    </form>
  );
}
